<div class="col-md-12 col-sm-12 col-xs-12 myprofile_flex_items padding-right40">
  @if (accountDetails; as item) {
    <div class="myprofile_content ">
      <div class="row">
        <div class="col-md-9 col-sm-9 col-xs-9">
          <div class="myprofile_tophybrisheader">{{"accountinfo.title" | cxTranslate}}</div>
        </div>
        <!-- <ng-container *ngIf="item.status=='Active'"> -->
        @if (item.status=='Active') {
          @if (!toggleEdit) {
            <div class="col-md-3 col-sm-4 col-xs-4" (click)="edit()">
              <div class="myprofile_edit" id="myprofile_editbtn">{{"profile.editlabel" | cxTranslate}}<img src="/assets/images/edit.png" width="20"
                alt="Edit">
              </div>
            </div>
          }
        }
      </div>
      @if (!toggleEdit) {
        <div class="myprofile_view">
          <div class="row account_Num_Name_row">
            <div class="col-md-5 col-sm-6 col-xs-12">
              <div class="myprofile_hybrisheader">{{"accountinfo.accnolabel" | cxTranslate}}</div><span
            class="myprofile_hybrisheader_txt">{{item?.accountNumber?item?.accountNumber:'N/A'}}</span>
          </div>
          <div class="col-md-7 col-sm-6 col-xs-8">
            <div class="myprofile_hybrisheader">{{"accountinfo.companylabel" | cxTranslate}}</div> <span
          class="myprofile_hybrisheader_txt">{{item?.organizationName?item?.organizationName:'N/A'}}</span>
        </div>
      </div>
      <div class="row margin-T20">
        <div class="col-md-5 col-sm-6 col-xs-12">
          <div class="myprofile_hybrisheader">{{"accountinfo.statuslabel" | cxTranslate}}</div><span class="myprofile_hybrisheader_txt_sub"
        id="status">{{item?.status}}</span>
      </div>
      <div class="col-md-7 col-sm-6 col-xs-12">
        <div class="myprofile_hybrisheader_sub_txt">{{"accountinfo.locslabel" | cxTranslate}}</div>
        <span
        class="myprofile_company_txt">{{item?.locationCount?item?.locationCount:'N/A'}}</span>
      </div>
    </div>
    <div class="row margin-T20">
      <div class="col-md-5 col-sm-6 col-xs-12">
        <div class="myprofile_hybrisheader_sub_txt">{{"accountinfo.addrlabel" | cxTranslate}}</div>
        <div class="myprofile_company_address">
        {{item?.line1?item?.line1:'N/A'}} &nbsp; </div>
      </div>
      <div class="col-md-7 col-sm-6 col-xs-12">
        <div class="myprofile_hybrisheader_sub_txt">{{"accountinfo.glnlabel" | cxTranslate}}</div>
        <span
        class="myprofile_company_txt myprofile_company_gln">{{ formatNumber(item?.globalLocationNumber) }}</span>
      </div>
    </div>
  </div>
}
@if (toggleEdit) {
  <div class="myprofile_editview toggle_Open">
    <div class="row">
      <div class="col-md-9 col-sm-12 col-xs-12 margin-T10">
        <div class="myprofile_editheader_txt ">{{"accountinfo.contactinfotitle" | cxTranslate}} &nbsp;&nbsp;&nbsp;<a
          (click)="showRequestModal('request')"
          id="myprofile_request"><span class="myprofile_editheader_txt_sub">{{"accountinfo.reqchangestext" | cxTranslate}}</span></a>
        </div>
      </div>
    </div>
    <form  id="myprofile_editForm" [formGroup]="customerRegisterForm" method="post" novalidate="novalidate">
      <div class="row margin-T10">
        <div class="col-md-6 col-sm-6 col-xs-12">
          <label class="myprofile_editcompany_txt" for="Account-no">{{"accountinfo.accnolabel" | cxTranslate}}</label>
          <input class="myprofile_input form-control" formControlName="Accountno" id="Account-no" name="Account-no" value="" >
        </div>
        <div class="col-md-6 col-sm-6 col-xs-12">
          <label class="myprofile_editcompany_txt" for="company-name">{{"accountinfo.companylabel" | cxTranslate}}</label>
          <input class="myprofile_input form-control" formControlName="companyname" id="company-name" name="company-name"
            value="" >
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12">
            <label class="myprofile_editcompany_txt" for="locations-count">{{"accountinfo.locslabel" | cxTranslate}}</label>
            <input class="myprofile_input form-control" formControlName="locationscount" id="locations-count" name="locations-count"
              value=""  >
            </div>
          </div>
          <div class="row margin-T20">
            <div class="col-md-6 col-sm-6 col-xs-12">
              <label class="myprofile_editbusinessinfo_txt">{{"accountinfo.businessinfolabel" | cxTranslate}}</label><br/>
              <label class="myprofile_editbusinessinfo_txt_sub">{{"accountinfo.businessAddrlabel" | cxTranslate}}</label>
            </div>
          </div>
          <div class="row margin-T10">
            <div class="col-md-6 col-sm-6 col-xs-12 glnmask">
              <label class="myprofile_editcompany_txt" for="myprofile_GLN">{{"accountinfo.glnfieldlabel" | cxTranslate}}<i (mouseenter)="showTooltip()" (mouseleave)="hideTooltip()" class="fa fa-question-circle-o locations_glntool locations_tooltip">
                @if (showtool) {
                  <span class="locations_tooltiptext" [innerHTML]="'accountinfo.glntooltip' | cxTranslate"></span>
                }
              </i>
            </label>
            <p-inputMask class="myprofile_Address_input form-control" autoClear="false" mask="9999999.99999.9" pattern="\d\d\d\d\d\d\d\.\d\d\d\d\d\.\d" id="myprofile_GLN" name="orgAddressForm.globalLocationNumber" formControlName="globalLocationNumber" />
            @if (customerRegisterForm.controls['globalLocationNumber'].invalid && (customerRegisterForm.controls['globalLocationNumber'].touched || customerRegisterForm.controls['globalLocationNumber'].dirty)) {
              <div class="text-danger">
                <span class="glyphicon glyphicon-exclamation-sign"></span>
                @if (customerRegisterForm.controls['globalLocationNumber'].errors?.['pattern']) {
                  <label class="error help-block">{{"accountinfo.glnerrormsg" | cxTranslate}}</label>
                }
              </div>
            }
          </div>
        </div>
        <div class="row margin-T10">
          <div class="col-md-6 col-sm-6 col-xs-12">
            <label class="myprofile_editcompany_txt" for="myprofile_Address1">{{"accountinfo.addrLine1" | cxTranslate}}</label>
            <div class="input-group">
              <input class="myprofile_Address_input form-control" id="myprofile_Address1"
                name="orgAddressForm.Line1" formControlName="line1" value="">
                @if (getFormControl('line1').touched && (getFormControl('line1').hasError('required'))) {
                  <span class="input-group-addon">
                    <span class="glyphicon glyphicon-exclamation-sign"></span>
                  </span>
                }
              </div>
              @if (getFormControl('line1').touched && (getFormControl('line1').hasError('required'))) {
                <!-- <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span> -->
                <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"accountinfo.addrerrormsg" | cxTranslate}}</label>
              }
            </div>
          </div>
          <div class="row margin-T10">
            <div class="col-md-6 col-sm-6 col-xs-12">
              <label class="myprofile_editcompany_txt" for="myprofile_Address2">{{"accountinfo.addrLine2" | cxTranslate}}</label>
              <input class="myprofile_Address_input form-control" id="myprofile_Address2" value=""
                name="orgAddressForm.line2" formControlName="line2">
              </div>
            </div>
            <div class="row margin-T10">
              <div class="col-md-6 col-sm-6 col-xs-12">
                <label class="myprofile_editcompany_txt" for="myprofile_city">{{"accountinfo.city" | cxTranslate}}</label>
                <div class="input-group">
                  <input class="myprofile_Address_input form-control" id="myprofile_city"
                    name="orgAddressForm.city" formControlName="city" value="">
                    @if (getFormControl('city').touched && (getFormControl('city').hasError('required') || getFormControl('city').hasError('pattern'))) {
                      <span class="input-group-addon">
                        <span class="glyphicon glyphicon-exclamation-sign"></span>
                      </span>
                    }
                  </div>
                  @if (getFormControl('city').touched && (getFormControl('city').hasError('required') || getFormControl('city').hasError('pattern'))) {
                    <!-- <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span> -->
                    @if (getFormControl('city').hasError('required')) {
                      <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"accountinfo.cityerrormsg1" | cxTranslate}}</label>
                    }
                    @if (getFormControl('city').hasError('pattern')) {
                      <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"accountinfo.cityerrormsg2" | cxTranslate}}</label>
                    }
                  }
                </div>
              </div>
              <div class="row margin-T10 stateZip">
                <div class="col-md-3 col-sm-6 col-xs-6">
                  <label class="myprofile_editcompany_txt" for="myprofile_state">{{"accountinfo.state" | cxTranslate}}</label>
                  <select class="myprofile_state form-control" formControlName="state" id="myprofile_state">
                    @for (state of statesList; track state) {
                      <option [value]="state">{{state}}</option>
                    }
                  </select>
                </div>
                <div class="col-md-2 col-sm-6 col-xs-6">
                  <label class="myprofile_editcompany_txt" for="myprofile_zipcode">{{"accountinfo.zip" | cxTranslate}}</label>
                  <div class="input-group">
                    <input class="myprofile_Address_input form-control myprofile_zipcode" id="myprofile_zipcode"
                      name="orgAddressForm.postalCode" value="" formControlName="postalCode">
                      @if (getFormControl('postalCode').invalid && getFormControl('postalCode').touched) {
                        <span class="input-group-addon">
                          <span class="glyphicon glyphicon-exclamation-sign"></span>
                        </span>
                      }
                    </div>
                    @if (getFormControl('postalCode').touched && (getFormControl('postalCode').hasError('required') || getFormControl('postalCode').hasError('pattern'))) {
                      <!-- <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span> -->
                      @if (getFormControl('postalCode').hasError('required')) {
                        <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"accountinfo.ziperrormsg" | cxTranslate}}</label>
                      }
                      @if (getFormControl('postalCode').hasError('pattern')) {
                        <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"accountinfo.ziperrormsg" | cxTranslate}}</label>
                      }
                    }
                  </div>
                </div>
                <input type="hidden" name="orgAddressForm.addressId" value="SP0000376350">
                <input type="hidden" name="orgAddressForm.modifiedQualifiers" value="" id="modifiedQualifiers"
                  modified-id="orgAddressForm.addressId">
                  <div class="row margin-T30">
                    <div class="col-md-5 col-sm-6 col-xs-12"> </div>
                    <div class="col-md-7 col-sm-6 col-xs-12">
                      <div class="col-md-6 col-sm-6 col-xs-6 no-padding">
                        <button (click)="edit()" type="button" class="myprofile_cancel"
                        id="myprofile_cancel">{{"profile.cancellabel" | cxTranslate}}</button>
                      </div>
                      <div class="col-md-6 col-sm-6 col-xs-6 no-padding">
                        <button (click)="submitBusinessDetails()" type="submit" class="myprofile_submit" id="myprofile_submit">{{"profile.submitlabel" | cxTranslate}}</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            }
          </div>
        }
      </div>